import { useT } from '@/shared/i18n'

/** The stopwatch brings most search traffic, so it opens the catalog. */
const FIRST_TOOL_HREF = '/sekundomer'

export function IndexPage() {
  const t = useT()
  const tools = [...t.index.tools].sort(
    (a, b) => Number(b.href === FIRST_TOOL_HREF) - Number(a.href === FIRST_TOOL_HREF),
  )

  return (
    <div className="mx-auto max-w-6xl">
      <section className="pb-4 pt-1 sm:pb-6">
        <h1 className="text-2xl font-bold tracking-normal sm:text-3xl">{t.index.title}</h1>
        <p className="mt-1 max-w-3xl text-sm leading-6 text-muted-foreground sm:text-base sm:leading-7">
          {t.index.description}
        </p>
      </section>

      <section className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {tools.map((tool) => (
          <a
            key={tool.href}
            href={tool.href}
            className="block rounded-lg border bg-card p-4 text-card-foreground shadow-sm transition-colors hover:border-primary/40 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <h2 className="text-base font-semibold tracking-normal">{tool.title}</h2>
            <p className="mt-1 text-sm leading-6 text-muted-foreground">{tool.description}</p>
          </a>
        ))}
      </section>
    </div>
  )
}
